/* eslint-disable import/prefer-default-export */
import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init } = createAllActions(types.SCOPE);

const updateBase = (persistedState) => ({
  type: types.UPDATE,
  persistedState,
});

const setSelectedMetric = (widgetIndex, metricName) => ({
  type: types.SET_SELECTED_METRIC,
  widgetIndex,
  metricName,
});

const setSelectedDimension = (widgetIndex, dimensionIndex, dimension) => ({
  type: types.SET_SELECTED_DIMENSION,
  widgetIndex,
  dimensionIndex,
  dimension,
});

const swapSelectedDimensions = (
  widgetIndex,
  dimensionIndex,
  dimension,
  swapIndex,
  swapDimension,
) => ({
  type: types.SWAP_SELECTED_DIMENSION,
  widgetIndex,
  dimensionIndex,
  dimension,
  swapIndex,
  swapDimension,
});

const setDimensionUnit = (widgetIndex, unit) => ({
  type: types.SET_DIMENSION_UNIT,
  widgetIndex,
  unit,
});

const setSelectedKPI = selectedKPIMetric => ({
  type: types.SET_SELECTED_KPI,
  selectedKPIMetric,
});

const dimensionDrilldown = (dimension, row) => ({
  type: types.DIMENSION_DRILLDOWN,
  dimension,
  row,
});

const applyFilter = filter => ({
  type: types.APPLY_FILTER,
  filter,
});

const setInterval = interval => ({
  type: types.SET_INTERVAL,
  ...interval,
});

const resetBreadcrumb = () => ({
  type: types.RESET_BREADCRUMB,
});

const pushBreadcrumb = filter => ({
  type: types.PUSH_BREADCRUMB,
  filter,
});

const popBreadcrumb = (breadcrumb, index) => ({
  type: types.POP_BREADCRUMB,
  breadcrumb,
  index,
});

const fetchSelectedKPI = () => ({
  type: types.FETCH_SELECTED_KPI_CONFIG,
});

const setSelectedKPIId = (data) => ({
  type: types.SET_SELECTED_KPI_CONFIG,
  selectedKPI: data
});

const persistState = configuration => ({
  type: types.PERSIST_STATE,
  configuration,
});

export {
  init,
  updateBase,
  persistState,
  setSelectedMetric,
  setSelectedDimension,
  swapSelectedDimensions,
  setDimensionUnit,
  setSelectedKPI,
  dimensionDrilldown,
  applyFilter,
  setInterval,
  resetBreadcrumb,
  pushBreadcrumb,
  popBreadcrumb,
  setSelectedKPIId,
  fetchSelectedKPI
};
